"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var _slicedToArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Graphics = require("../../graphics");

var Specification = require("../../specification");

var emphasis_1 = require("./emphasis");

var text_attrs_1 = require("./text.attrs");

var plot_segments_1 = require("../plot_segments");

var TextElementClass =
/*#__PURE__*/
function (_emphasis_1$Emphasiza) {
  _inherits(TextElementClass, _emphasis_1$Emphasiza);

  function TextElementClass() {
    var _this;

    _classCallCheck(this, TextElementClass);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextElementClass).apply(this, arguments));
    _this.attributes = text_attrs_1.textAttributes;
    _this.attributeNames = Object.keys(text_attrs_1.textAttributes);
    return _this;
  } // Initialize the state of an element so that everything has a valid value


  _createClass(TextElementClass, [{
    key: "initializeState",
    value: function initializeState() {
      var attrs = this.state.attributes;
      attrs.x = 0;
      attrs.y = 0;
      attrs.text = "Text";
      attrs.fontFamily = "Arial";
      attrs.fontSize = 14;
      attrs.color = {
        r: 0,
        g: 0,
        b: 0
      };
      attrs.visible = true;
      attrs.outline = null;
      attrs.opacity = 1;
    } // Get intrinsic constraints between attributes (e.g., x2 - x1 = width for rectangles)

  }, {
    key: "buildConstraints",
    value: function buildConstraints(solver) {} // Get the graphical element from the element

  }, {
    key: "getGraphics",
    value: function getGraphics(cs, offset) {
      var glyphIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var manager = arguments.length > 3 ? arguments[3] : undefined;
      var empasized = arguments.length > 4 ? arguments[4] : undefined;
      var attrs = this.state.attributes;
      var props = this.object.properties;

      if (!attrs.visible || !this.object.properties.visible) {
        return null;
      }

      var metrics = Graphics.TextMeasurer.Measure(attrs.text, attrs.fontFamily, attrs.fontSize);

      var _Graphics$TextMeasure = Graphics.TextMeasurer.ComputeTextPosition(0, 0, metrics, props.alignment.x, props.alignment.y, props.alignment.xMargin, props.alignment.yMargin),
          _Graphics$TextMeasure2 = _slicedToArray(_Graphics$TextMeasure, 2),
          dx = _Graphics$TextMeasure2[0],
          dy = _Graphics$TextMeasure2[1];

      var p = cs.getLocalTransform(attrs.x + offset.x, attrs.y + offset.y);
      p.angle += props.rotation;
      var text = Graphics.makeText(dx, dy, attrs.text, attrs.fontFamily, attrs.fontSize, Object.assign({
        strokeColor: attrs.outline,
        fillColor: attrs.color,
        opacity: attrs.opacity
      }, this.generateEmphasisStyle(empasized)));
      var parent = manager.getMarkClass(this.state);
      var datum = "";

      while (parent !== null) {
        parent = parent.parent;

        if (parent instanceof plot_segments_1.PlotSegmentClass) {
          var _ret = function () {
            var datums = parent.state.dataRowIndices[glyphIndex];

            if (datums.length == 1) {
              datum = JSON.stringify(Object.assign({
                _TYPE: "text",
                _MARKID: props.name,
                _x: cs.getBaseTransform().x + offset.x,
                _y: cs.getBaseTransform().y + offset.y
              }, manager.dataset.tables[0].rows[datums[0]]));
            } else {
              datum = JSON.stringify(datums.map(function (i) {
                return Object.assign({
                  _TYPE: "text",
                  _MARKID: props.name,
                  _x: cs.getBaseTransform().x + offset.x,
                  _y: cs.getBaseTransform().y + offset.y
                }, manager.dataset.tables[0].rows[datums[i]]);
              }));
            }

            return "break";
          }();

          if (_ret === "break") break;
        }
      }

      text["data-datum"] = datum;
      var g = Graphics.makeGroup([text]);
      g.transform = p;
      return g;
    } // Get DropZones given current state

  }, {
    key: "getDropZones",
    value: function getDropZones() {
      return [Object.assign({
        type: "rectangle"
      }, this.getBoundingRectangle(), {
        title: "text",
        dropAction: {
          scaleInference: {
            attribute: "text",
            attributeType: Specification.AttributeType.Text
          }
        }
      })];
    } // Get bounding rectangle given current state

  }, {
    key: "getHandles",
    value: function getHandles() {
      var attrs = this.state.attributes;
      var props = this.object.properties;
      var x = attrs.x,
          y = attrs.y,
          x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2;
      var bbox = this.getBoundingRectangle();
      return [{
        type: "point",
        x: x,
        y: y,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y"
        }]
      }, {
        type: "text-alignment",
        actions: [{
          type: "property",
          source: "alignment",
          property: "alignment"
        }, {
          type: "property",
          source: "rotation",
          property: "rotation"
        }, {
          type: "attribute-value-mapping",
          source: "text",
          attribute: "text"
        }],
        textWidth: bbox.width,
        textHeight: bbox.height,
        anchorX: x,
        anchorY: y,
        text: attrs.text,
        alignment: props.alignment,
        rotation: props.rotation
      }];
    }
  }, {
    key: "getBoundingRectangle",
    value: function getBoundingRectangle() {
      var props = this.object.properties;
      var attrs = this.state.attributes;
      var metrics = Graphics.TextMeasurer.Measure(attrs.text, attrs.fontFamily, attrs.fontSize);

      var _Graphics$TextMeasure3 = Graphics.TextMeasurer.ComputeTextPosition(0, 0, metrics, props.alignment.x, props.alignment.y, props.alignment.xMargin, props.alignment.yMargin),
          _Graphics$TextMeasure4 = _slicedToArray(_Graphics$TextMeasure3, 2),
          dx = _Graphics$TextMeasure4[0],
          dy = _Graphics$TextMeasure4[1];

      var cx = dx + metrics.width / 2;
      var cy = dy + metrics.middle;
      var rotation = this.object.properties.rotation;
      var cos = Math.cos(rotation / 180 * Math.PI);
      var sin = Math.sin(rotation / 180 * Math.PI);
      return {
        cx: attrs.x + cx * cos - cy * sin,
        cy: attrs.y + cx * sin + cy * cos,
        width: metrics.width,
        height: (metrics.middle - metrics.ideographicBaseline) * 2,
        rotation: rotation
      };
    }
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox() {
      var rect = this.getBoundingRectangle();
      var attrs = this.state.attributes;
      return {
        type: "anchored-rectangle",
        anchorX: attrs.x,
        anchorY: attrs.y,
        cx: rect.cx - attrs.x,
        cy: rect.cy - attrs.y,
        width: rect.width,
        height: rect.height,
        rotation: rect.rotation
      };
    }
  }, {
    key: "getSnappingGuides",
    value: function getSnappingGuides() {
      var attrs = this.state.attributes;
      var x = attrs.x,
          y = attrs.y,
          x1 = attrs.x1,
          y1 = attrs.y1,
          x2 = attrs.x2,
          y2 = attrs.y2;
      return [{
        type: "x",
        value: x,
        attribute: "x"
      }, {
        type: "y",
        value: y,
        attribute: "y"
      }];
    }
  }, {
    key: "getAttributePanelWidgets",
    value: function getAttributePanelWidgets(manager) {
      var props = this.object.properties;
      return [manager.sectionHeader("Text"), manager.mappingEditor("Text", "text", {}), manager.mappingEditor("Font", "fontFamily", {
        defaultValue: "Arial"
      }), manager.mappingEditor("Size", "fontSize", {
        hints: {
          rangeNumber: [0, 36]
        },
        defaultValue: 14,
        numberOptions: {
          showUpdown: true,
          updownStyle: "font",
          minimum: 0,
          updownTick: 2
        }
      }), manager.sectionHeader("Anchor & Rotation"), manager.row("Anchor X", manager.horizontal([0, 1], manager.inputSelect({
        property: "alignment",
        field: "x"
      }, {
        type: "radio",
        icons: ["text-align/left", "text-align/x-middle", "text-align/right"],
        labels: ["Left", "Middle", "Right"],
        options: ["left", "middle", "right"]
      }), props.alignment.x != "middle" ? manager.horizontal([0, 1], manager.label("Margin:"), manager.inputNumber({
        property: "alignment",
        field: "xMargin"
      }, {
        updownTick: 1,
        showUpdown: true
      })) : null)), manager.row("Anchor Y", manager.horizontal([0, 1], manager.inputSelect({
        property: "alignment",
        field: "y"
      }, {
        type: "radio",
        icons: ["text-align/top", "text-align/y-middle", "text-align/bottom"],
        labels: ["Top", "Middle", "Bottom"],
        options: ["top", "middle", "bottom"]
      }), props.alignment.y != "middle" ? manager.horizontal([0, 1], manager.label("Margin:"), manager.inputNumber({
        property: "alignment",
        field: "yMargin"
      }, {
        updownTick: 1,
        showUpdown: true
      })) : null)), // manager.row("Rotation", manager.inputNumber({ property: "rotation" })),
      manager.sectionHeader("Style"), manager.mappingEditor("Color", "color", {}), manager.mappingEditor("Outline", "outline", {}), manager.mappingEditor("Opacity", "opacity", {
        hints: {
          rangeNumber: [0, 1]
        },
        defaultValue: 1,
        numberOptions: {
          showSlider: true,
          minimum: 0,
          maximum: 1
        }
      }), manager.mappingEditor("Visibility", "visible", {
        defaultValue: true
      })];
    }
  }, {
    key: "getTemplateParameters",
    value: function getTemplateParameters() {
      if (this.object.mappings.text && this.object.mappings.text.type != "value") {
        return null;
      } else {
        return {
          properties: [{
            objectID: this.object._id,
            target: {
              attribute: "text"
            },
            type: Specification.AttributeType.Text,
            default: this.state.attributes.text
          }]
        };
      }
    }
  }]);

  return TextElementClass;
}(emphasis_1.EmphasizableMarkClass);

TextElementClass.classID = "mark.text";
TextElementClass.type = "mark";
TextElementClass.metadata = {
  displayName: "Text",
  iconPath: "mark/text",
  creatingInteraction: {
    type: "point",
    mapping: {
      x: "x",
      y: "y"
    }
  }
};
TextElementClass.defaultMappingValues = {
  text: "Text",
  fontFamily: "Arial",
  fontSize: 14,
  color: {
    r: 0,
    g: 0,
    b: 0
  },
  opacity: 1,
  visible: true
};
TextElementClass.defaultProperties = {
  alignment: {
    x: "middle",
    y: "top",
    xMargin: 5,
    yMargin: 5
  },
  rotation: 0,
  visible: true
};
exports.TextElementClass = TextElementClass;